import SwitchDeviceModal from './SwitchDeviceModal';

export default SwitchDeviceModal;
